//
// AGNES - Technical Support Web
//
// WarrantyContractBrowseController.js
//
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//

angular.module("Agnes")
    .controller("WarrantyContractBrowseController", [
        "$scope", "$sessionStorage", "$http", "$uibModal", "$activity", "$notification", "$location", "$oidc",
        function ($scope, $sessionStorage, $http, $modal, $activity, $notification, $location, oidc) {
            // Storage
            $scope.$storage = $sessionStorage.$default({
                warrantyContractBrowse: {
                    search: null,
                    status: [1, 2, 3, 4, 5, 6],
                    from: null,
                    to: null,
                    orderName: "PolicySoldDate",
                    orderDesc: true
                }
            });

            $scope.setVin = function () {
                if ($location.search()["vin"]) {
                    $scope.$storage.warrantyContractBrowse.from = null;
                    $scope.$storage.warrantyContractBrowse.to = null;
                    return $location.search()["vin"];
                }

                return "";
            }

            $scope.$storage.warrantyContractBrowse.search = $scope.setVin();

            // Repairer
            $scope.$watch("$storage.repairer", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty(newValue) && newValue.id !== -1 && newValue.id !== oldValue.id) {
                    $scope.refresh();
                }
            });

            // Date pickers
            $scope.fromOpen = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.popupFromOpen.opened = true;
            };

            $scope.popupFromOpen = {
                opened: false
            };

            $scope.toOpen = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.popupToOpen.opened = true;
            };

            $scope.popupToOpen = {
                opened: false
            };

            // Browse
            $scope.sorting = function (orderName) {
                if ($scope.$storage.warrantyContractBrowse.orderName === orderName) {
                    $scope.$storage.warrantyContractBrowse.orderDesc = !$scope.$storage.warrantyContractBrowse.orderDesc;
                } else {
                    $scope.$storage.warrantyContractBrowse.orderName = orderName;
                    $scope.$storage.warrantyContractBrowse.orderDesc = false;
                }
            };

            $scope.sortingClass = function (orderName) {
                if ($scope.$storage.warrantyContractBrowse.orderName === orderName) {
                    if ($scope.$storage.warrantyContractBrowse.orderDesc) {
                        return "fa fa-caret-down";
                    } else {
                        return "fa fa-caret-up";
                    }
                } else {
                    return "";
                }
            };

            // contract detail popup
            $scope.showWarrantyContractDetail = function (item) {
                $modal.open({
                    template: require("../Templates/WarrantyContractDetail.html"),
                    controller: "WarrantyContractDetailController",
                    resolve: {
                        id: function () {
                            return item.id;
                        }
                    }
                });
            };

            $scope.loadStatuses = function () {
                $activity.start();
                $http
                    .get("/api/warranty-contract-status", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.statuses = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.refresh = function () {
                $activity.start();
                $http
                    .get("/api/warranty-contract/browse/" + $scope.$storage.repairer.id, {
                        params: {
                            search: $scope.$storage.warrantyContractBrowse.search,
                            status: $scope.$storage.warrantyContractBrowse.status,
                            from: $scope.$storage.warrantyContractBrowse.from,
                            to: $scope.$storage.warrantyContractBrowse.to
                        },
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.list = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            // On Load
            if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1) {
                //$scope.loadStatuses();
                $scope.refresh();
            }
        }
    ]);